import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaStar,
  FaMapMarkerAlt,
  FaArrowRight,
  FaPaperPlane
} from "react-icons/fa";

import "./HolidayHero.css";

const HolidayHero = () => {

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    destination: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    setLoading(true);

    try {

      const response = await fetch(
        "http://localhost:5000/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(formData)
        }
      );

      const data = await response.json();

      alert(data.message);

      setFormData({
        name: "",
        mobile: "",
        destination: ""
      });

    } catch (error) {

      alert("Something Went Wrong");

    }

    setLoading(false);
  };

  // Parent Container Animation
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  // Elements Animation
  const fadeInUp = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    },
  };

  // Form Input Animation
  const inputVariants = {
    hidden: { x: -20, opacity: 0 },
    visible: { x: 0, opacity: 1 },
  };

  return (
    <section className="holiday-hero">

      <div className="hero-gradient-overlay"></div>

      <motion.div
        className="hero-wrapper"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
      >

        {/* LEFT CONTENT */}
        <div className="hero-text-content">

          <motion.div
            variants={fadeInUp}
            className="hero-badge"
          >
            <span className="dot"></span>
            A TRAVEL YOU'LL REMEMBER FOR A LIFETIME
          </motion.div>

          <motion.h1 variants={fadeInUp}>
            Escape to the <br />
            <span className="text-orange">
              Majestic Mountains
            </span>
          </motion.h1>

          <motion.p variants={fadeInUp}>
            Experience premium stays and expert-guided tours.
            Chandrama Holidays brings you the most trusted
            Himalayan escape for unforgettable memories.
          </motion.p>

          <motion.div
            variants={fadeInUp}
            className="hero-features"
          >

            <div className="feature-item">
              <FaStar className="icon-star" />
              <span>4.9 Customer Rating</span>
            </div>

            <div className="feature-item">
              <FaMapMarkerAlt className="icon-map" />
              <span>Verified Routes</span>
            </div>

          </motion.div>

        </div>

        {/* RIGHT SIDE FORM */}
        <motion.div
          className="holiday-booking-card"
          initial={{
            opacity: 0,
            scale: 0.9,
            rotateY: 20
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
            rotateY: 0
          }}
          viewport={{ once: false }}
          transition={{
            duration: 0.8,
            type: "spring",
            bounce: 0.4
          }}
        >

          <div className="card-header">

            <motion.div
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              transition={{
                delay: 0.5,
                type: "spring"
              }}
              className="icon-circle"
            >
              <FaPaperPlane />
            </motion.div>

            <h3>Book Your Trip</h3>

            <p>
              Fill the form to get an instant callback.
            </p>

          </div>

          <form
            className="booking-form"
            onSubmit={handleSubmit}
          >

            <motion.div
              variants={inputVariants}
              className="form-group"
            >

              <motion.input
                whileFocus={{
                  scale: 1.02,
                  borderColor: "#F7931E"
                }}
                type="text"
                name="name"
                placeholder="Full Name"
                required
                value={formData.name}
                onChange={handleChange}
              />

            </motion.div>

            <motion.div
              variants={inputVariants}
              className="form-group"
            >

              <motion.input
                whileFocus={{
                  scale: 1.02,
                  borderColor: "#F7931E"
                }}
                type="tel"
                name="mobile"
                placeholder="Mobile Number"
                required
                value={formData.mobile}
                onChange={handleChange}
              />

            </motion.div>

            <motion.div
              variants={inputVariants}
              className="form-group"
            >

              <motion.select
                whileFocus={{
                  scale: 1.02,
                  borderColor: "#F7931E"
                }}
                name="destination"
                required
                value={formData.destination}
                onChange={handleChange}
              >

                <option value="">
                  Select Destination
                </option>

                <option value="Manali Special">
                  Manali Special
                </option>

                <option value="Shimla Queen">
                  Shimla Queen
                </option>

                <option value="Lahaul & Spiti">
                  Lahaul & Spiti
                </option>

                <option value="Dharamshala">
                  Dharamshala
                </option>

              </motion.select>

            </motion.div>

            <motion.button
              type="submit"
              className="quote-btn"
              disabled={loading}
              whileHover={{
                scale: 1.05,
                boxShadow:
                  "0px 0px 20px rgba(247, 147, 30, 0.5)"
              }}
              whileTap={{ scale: 0.95 }}
            >

              {
                loading
                  ? "Sending..."
                  : "Submit Enquiry"
              }

            </motion.button>

          </form>

        </motion.div>

      </motion.div>

    </section>
  );
};

export default HolidayHero;